import clsx from 'clsx'
import React from 'react'

import { ArrowDropDownFilledIcon } from '@/components/icons/ArrowDropDownFilled'

import { Icon } from '../icon'
import { DisclosureProps } from './type'

export const Disclosure = ({
  isOpen,
  heading,
  children,
  disabled = false,
  headerClassName = 'tw-bg-white tw-text-xs',
  withSpace = {
    title: false,
    content: false,
  },
  toggle,
}: DisclosureProps) => {
  return (
    <>
      <div
        className={clsx(
          'tw-flex tw-min-h-[44px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-between',
          withSpace.title && 'tw-px-4',
          headerClassName,
          'tw-transition tw-duration-stateChange',
          'hover:tw-opacity-hover',
          'focus:tw-outline-none',
          !disabled && 'tw-cursor-pointer'
        )}
        onClick={disabled ? undefined : toggle}
      >
        {heading}
        <Icon
          icon={ArrowDropDownFilledIcon}
          size={'2xl'}
          color={'description'}
          className={clsx(
            isOpen && 'tw-rotate-180 tw-transform',
            disabled && 'tw-opacity-30'
          )}
        />
      </div>
      {isOpen && (
        <div
          className={clsx(
            withSpace.content && 'tw-px-4',
            'tw-border-t tw-border-gray-300'
          )}
        >
          {children}
        </div>
      )}
    </>
  )
}
